import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { ErrorPage, NotFound } from 'infrastructure/error';
import AccountV2, {
  ForgotPassword,
  ResetPassword,
  PasswordResetConfirmation,
} from 'slices/AccountV2/Loadable';
import { Preview as StoryPreview } from 'slices/Story/Loadable';
import { Preview as InterstitialAdPreview } from 'slices/InterstitialAdv2/Loadable';
import { Preview as ClipPreview } from 'slices/Clips/Loadable';
import { Preview as CardPreview } from 'slices/Cards/Loadable';
import PremierePublisherBrowser from 'slices/PremierePublisherBrowser/Loadable';
import Dashboard from './Dashboard';

const AppRouter = () => {
  const { location } = useLocation();

  return (
    <div className="wrapper theme-lightondark d-flex flex-column min-vh-100">
      <Switch location={location}>
        <Route exact path="/login" component={AccountV2} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route
          path="/password-reset-confirmation"
          component={PasswordResetConfirmation}
        />
        <Route path="/error" component={ErrorPage} />
        <Route path="/500" component={ErrorPage} />
        <Route path="/404" component={NotFound} />
        <Route path="/premiere" component={PremierePublisherBrowser} />
        <Route path="/stories/:id/preview/public" component={StoryPreview} />
        <Route
          path="/interstitialAd/:id/preview/public"
          component={InterstitialAdPreview}
        />
        <Route path="/clips/:id/preview/public" component={ClipPreview} />
        <Route path="/cards/:id/preview/public" component={CardPreview} />
        <Route path="/" component={Dashboard} />
      </Switch>
    </div>
  );
};

export default AppRouter;
